/* ============ Build a set, pick any three tees, save ₹500 ============ */
(function build(){
  const $=s=>document.querySelector(s);
  if(!$('#bsSlots')||!window.OSO_PRODUCTS) return;
  if(window.osoAmbient) osoAmbient();
  const rup=n=>'₹'+n.toLocaleString('en-IN');
  const SET=3, SAVING=500;
  /* three slots, each {p, hex, cn, size} or null */
  const slots=[null,null,null];
  let tab='all';

  const emptySlot=i=>`<div class="im"><span class="num">${i+1}</span>
      <div class="bs-empty"><svg viewBox="0 0 24 24"><path d="M8 4 5 6 3 9l2.5 2L7 9.5V20h10V9.5L18.5 11 21 9l-2-3-3-2a4 4 0 0 1-8 0Z"/></svg>
      <b>Slot ${i+1}</b><span>Pick a tee below</span></div></div>
    <div class="bs-b"><div class="nm">Empty</div><div class="cn">Nothing picked yet</div></div>`;

  const fullSlot=(s,i)=>`<div class="im"><span class="num">${i+1}</span><button class="x" data-x="${i}" aria-label="Remove">&times;</button>${shopTee(s.hex,s.p.print)}</div>
    <div class="bs-b"><div class="nm">${s.p.name}</div><div class="cn">${s.cn} · ${rup(s.p.price)}</div>
      <div class="bs-sz" data-slot="${i}" role="group" aria-label="Size">${OSO_sizesFor(s.p.id,OSO_colorKey(s.hex)).map(([z,n])=>
        `<button data-z="${z}" class="${z===s.size?'on':''}${n?'':' oos'}"${n?'':' disabled'}>${z}</button>`).join('')}</div></div>`;

  function renderSlots(){
    $('#bsSlots').innerHTML=slots.map((s,i)=>
      `<div class="bs-slot${s?' filled':''}">${s?fullSlot(s,i):emptySlot(i)}</div>`).join('');
  }

  function renderGrid(){
    const list=OSO_VARIANTS().filter(v=>tab==='all'||v.p.id===tab);
    $('#bsGrid').innerHTML=list.map(v=>{
      const picked=slots.some(s=>s&&s.p.id===v.p.id&&s.hex===v.hex);
      return `<button class="bs-opt${picked?' picked':''}" data-id="${v.p.id}" data-c="${v.hex}">
        <div class="im">${shopTee(v.hex,v.p.print)}</div>
        <div class="cb"><div class="n">${v.p.name}</div><div class="c">${v.cn}</div></div>
        <span class="picked">In your set</span></button>`;}).join('');
  }

  function renderBar(){
    const n=slots.filter(Boolean).length;
    const gross=slots.filter(Boolean).reduce((t,s)=>t+s.p.price,0);
    const off=n>=SET?SAVING:0;
    $('#bsState').textContent=n===0?'Pick 3 tees':(n<SET?`${SET-n} more to go`:'Your set is ready');
    $('#bsPrice').innerHTML=off?`<s>${rup(gross)}</s>${rup(gross-off)}`:rup(gross);
    $('#bsSave').textContent=off?`You save ${rup(off)}`:(n?`Add ${SET-n} more to save ${rup(SAVING)}`:'');
    const btn=$('#bsAdd'); btn.disabled=n<SET;
    btn.textContent=n<SET?`Add set to bag (${n}/${SET})`:'Add set to bag';
  }

  const paint=()=>{renderSlots();renderGrid();renderBar();};
  paint();

  /* picking a tee drops it in the first free slot; picking it again removes it */
  $('#bsGrid').addEventListener('click',e=>{
    const o=e.target.closest('.bs-opt'); if(!o) return;
    const p=OSO_findProduct(o.dataset.id), hex=o.dataset.c;
    const at=slots.findIndex(s=>s&&s.p.id===p.id&&s.hex===hex);
    if(at>=0){slots[at]=null;}
    else{
      const free=slots.indexOf(null);
      if(free<0){OSO_STORE&&OSO_STORE.toast('Your set is full, remove one first');return;}
      /* M unless this colourway has none left, then the first size it does have */
      slots[free]={p,hex,cn:OSO_colorName(hex),size:OSO_defaultSize(p.id,OSO_colorKey(hex))||'M'};
    }
    paint();
    const box=$('#bsSlots').children[at>=0?at:Math.max(0,slots.filter(Boolean).length-1)];
    if(box&&window.gsap) gsap.fromTo(box,{scale:.94},{scale:1,duration:.45,ease:'back.out(2)'});
  });

  /* remove + size, inside the slots */
  $('#bsSlots').addEventListener('click',e=>{
    const x=e.target.closest('[data-x]');
    if(x){slots[+x.dataset.x]=null;paint();return;}
    const z=e.target.closest('[data-z]'); if(!z) return;
    const i=+z.closest('.bs-sz').dataset.slot;
    if(slots[i]){slots[i].size=z.dataset.z;
      z.parentNode.querySelectorAll('button').forEach(b=>b.classList.toggle('on',b===z));}
  });

  $('#bsTabs').addEventListener('click',e=>{const t=e.target.closest('.bs-tab'); if(!t) return;
    document.querySelectorAll('.bs-tab').forEach(x=>x.classList.toggle('on',x===t));
    tab=t.dataset.id; renderGrid();
    if(window.gsap) gsap.from('.bs-opt',{y:14,autoAlpha:0,duration:.4,stagger:.03,ease:'power2.out'});});

  $('#bsAdd').addEventListener('click',()=>{
    const picks=slots.filter(Boolean); if(picks.length<SET||!window.OSO_STORE) return;
    picks.forEach(s=>OSO_STORE.addToCart(s.p.id,s.hex,s.cn,s.size,1));
    const b=$('#bsAdd'); b.classList.add('done'); b.textContent='Added to bag ✓'; b.disabled=true;
    setTimeout(()=>{(window.osoCartSynced?window.osoCartSynced():Promise.resolve()).then(()=>location.href='/cart')},900);
  });

  if(window.gsap){
    gsap.from('.bs-head > *',{y:20,autoAlpha:0,duration:.6,stagger:.08,ease:'power2.out'});
    gsap.from('.bs-slot',{y:26,autoAlpha:0,duration:.6,stagger:.09,ease:'power2.out',delay:.15});
    gsap.from('.bs-opt',{y:18,autoAlpha:0,duration:.5,stagger:.035,ease:'power2.out',delay:.3});
  }
})();
